export const formatName = (profile) => {
  if (!profile) return undefined;
  const { title, familyName, givenName } = profile;
  return (`${title || ''} ${familyName || ''} ${givenName || ''}`.trim()) || profile.email;
};